import { AxiosError } from "axios";

/**
 * The backend never emits field-keyed validation errors (see ui/CLAUDE.md
 * Gotchas) — 422s are a single flattened string, 400s a string[] of free-text
 * class-validator messages. So there's no per-field form-error mapping here,
 * just one message string forms can render inline instead of a global toast.
 */
export function apiErrorMessage(error: unknown): string {
    if (error instanceof AxiosError) {
        const message = error.response?.data?.message;
        if (Array.isArray(message)) return message.join("\n");
        if (typeof message === "string") return message;
    }
    return error instanceof Error ? error.message : "Something went wrong";
}

/** The HTTP status, when the failure came from the API at all. */
export function apiErrorStatus(error: unknown): number | undefined {
    return error instanceof AxiosError ? error.response?.status : undefined;
}
